<script setup lang="ts">
    import type { CallToAction, MenuItem } from '~/graphql/generated';

    export interface HeaderMobileNavItemsProps {
        menu: {
            items: MenuItem[] | undefined | null;
            cta?: CallToAction | null;
            ctavisibility?: string | null;
        };
        menuLevel: number;
        openLevel: (item: MenuItem) => void;
    }

    const props = defineProps<HeaderMobileNavItemsProps>();
    const nuxtApp = useNuxtApp();

    const trackAndOpenLevel = (item: MenuItem) => {
        nuxtApp.$gtm.pushEvent({
            event: 'click_navigation',
            navigation_menu_level: props.menuLevel,
            navigation_menu_id: textToId(item.title),
            interaction_type: 'click',
        });
        props.openLevel(item);
    };
</script>
<template>
    <div>
        <nuxt-link
            v-for="item in menu.items"
            :key="item.id"
            :class="[
                'mol-header-mobile-nav-items flex items-center justify-between text-balance transition-colors hover:text-woom-red focus:text-woom-red',
                item.type === 'featured' ? ' text-lg' : ' text-base',
                { 'gtm-click-navigation': !item.items?.length },
            ]"
            @click="trackAndOpenLevel(item)"
            v-bind="getMenuItemProps(item)">
            <atm-menu-item :item="item" />
        </nuxt-link>
    </div>
    <div class="my-4 flex flex-col">
        <slot></slot>
    </div>
    <div
        v-if="menu.cta && (!menu.ctavisibility || menu.ctavisibility !== 'desktop')"
        class="mt-12 shrink-0">
        <lazy-atm-button
            class="-translate-y-6"
            v-bind="ctaToButton(menu.cta)"
            kind="link">
            <template
                #icon
                v-if="menu.cta.icon && isAssetDataIcon(menu.cta.icon)">
                <component
                    :is="menu.cta.icon.data.icon"
                    class="h-6 w-6" />
            </template>
            <renderer-html :content="woomTextFormat(menu.cta.link?.label ?? $t('cta.moreInfo'))" />
        </lazy-atm-button>
    </div>
</template>
